import { API_GetString } from "@/api/Modules/CM04/STDSCM04C00";
import Papa from "papaparse";
import moment from "moment";

/**
 * ファイルをダウンロード
 * @param {*} dataUrl - ファイルソース
 * @param {*} filename ファイル名
 **/
const download = (dataUrl, filename) => {
  let link = document.createElement("a");
  link.href = dataUrl;
  link.download = filename;
  link.click();
  link = null;
};

/**
 * CSVログを出力
 * @param {*} pageID - ページID
 **/
const getCSVLogByPageID = (pageID) => {
  return API_GetString({ storageKey: pageID }).then((response) => {
    if (_.eq(response.result, "0000")) {
      let title = [
        "社員コード",
        "所属コード",
        "所属",
        "社員名",
        "結果",
        "エラー詳細",
      ];
      let fileName = "社員情報のインポート";
      switch (pageID) {
        // 社員の年末調整収集状況
        case "STDSDC04C07":
        case "STDSDR02C08":
          fileName = "社員情報への反映";
          break;
        // 「データ管理の達人」からのインポート
        case "STDSDC02C01":
          fileName = "「データ管理の達人」からのインポート";
          title = [
            "事業者コード",
            "事業者名",
            "法人個人区分",
            "結果",
            "エラー詳細",
          ];
          break;
        // 年末調整対象社員情報取込（ログ出力不要）
        case "STDSDC03C13":
          break;
        // ファイルインポート
        case "STDSDC01C05":
        case "STDSDC02C10":
        case "STDSDR02C02":
          fileName = "社員情報のインポート";
          break;

        default:
          break;
      }

      const csvRows = response.string
        .split('"')
        .filter((e) => e.split(",").length > 3);
      const data = [title, ...csvRows.map((e) => e.split(","))];
      // const csv = Papa.unparse(data);
      const csv = data
        .map((row) =>
          row.map((cell) => `"${cell.replaceAll("//r//n", "\n")}"`).join(",")
        )
        .join("\n");
      // 文字化け防止
      const bom = "\uFEFF";
      const dataURI = `data:text/csv;charset=utf-8,${encodeURIComponent(
        bom + csv
      )}`;
      const savedDate = moment().format("YYYYMMDD");
      function generateFileName(logDescription) {
        return `${logDescription}結果ログ_${savedDate}.csv`;
      }

      fileName = generateFileName(fileName);
      download(dataURI, fileName);
    }
  });
};

export { getCSVLogByPageID };
